import React, {useContext, useState} from "react";

import EditView from "../../component/EditView";
import Texto from "../../component/form/texto/Texto";

import TipoServico from "../../model/TipoServico";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import FormUtils from "../../utils/FormUtils";
import {TooltipPosition} from "../../component/form/TooltipPosition";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";

function TipoServicoEdit() {
    const { error } = useContext(MensagemContext) as MensagemContextType;
    const [entidade, setEntidade] = useState<TipoServico>({});

    const editEntidade = (data: TipoServico) => {
        setEntidade(data);
    }

    const entidadeOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, [e.target.id]: e.target.value });
    }

    const validar = async (): Promise<boolean> => {
        if (!entidade.nomeServico) {
            FormUtils.invalidarComponente(error, "Descrição é obrigatório.");
            return false;
        }

        return true;
    }

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <EditView title={ "Tipo serviço" }
                          id={`${process.env.REACT_APP_REST_TIPO_SERVICO}`}
                          entidade={ entidade }
                          onValidationHandler={ validar }
                          entidadeUseStateFunction={ editEntidade }>

                    <Texto id={ "nomeServico" } value={ entidade.nomeServico }
                           label={ "* Descrição" } size={ "100%" } maxLength={ 20 }
                           tooltip={"Informe a descrição"} tooltipPosition={TooltipPosition.TOP}
                           onChangeHandler={entidadeOnChangeHandler} />

                </EditView>
            </RoleBasedAccess>
        </>
    );
}

export default TipoServicoEdit;